import { Component, ChangeDetectorRef, Inject, Input, OnInit } from '@angular/core';
import { MediaModel } from '../media.model';
import { isNullOrWhitespace } from '../functions';
import { Globals } from '../globals';
import { WalletStats, WalletTemplateModel } from '../wallet-template.model';
import { Honeycomb } from 'src/app/shared/honeycomb-api/honeycomb-api';
import { AppleWalletPassStyle, GoogleWalletPassStyle } from '../wallet-passstyle-enum';
import { DOCUMENT } from '@angular/common';
import { TranslationService } from 'src/app/shared/translation.service';


@Component({
    selector: 'hc-digital-card-preview',
    templateUrl: './digital-card-preview.component.html',
    styleUrls: ['./digital-card-preview.component.scss']
})

export class DigitalCardPreviewComponent implements OnInit {

    @Input() public media: MediaModel;
    @Input() public cardName: string;
    @Input() public cardData: WalletTemplateModel[];
    @Input() public googleStats: WalletStats;
    @Input() public appleStats: WalletStats;
    @Input() public weekOldGoogleStats: WalletStats;
    @Input() public weekOldAppleStats: WalletStats;

    public logoSrc: string = '';
    public imgSrc: string = '';

    public googleStyle: string;
    public appleStyle: string;

    public getThumbSrc = (): string => {
        //if (isNullOrWhitespace(item.value)) { return ''; }
        //if (item.value.length > 40) { return ''; } // not GUID
        return this.globals.GetUrlPrefix() + '/api/gallery/thumbByID/50/'
            + this.media.walletGoogleLogoUID + '?tenantID=' + this.globals.getTenantID();
    }

    constructor(
        private globals: Globals,
        private cd: ChangeDetectorRef,
        private trans: TranslationService,
        @Inject(DOCUMENT) private document: Document,
    ) {
    }

    async ngOnInit() {
        this.logoSrc = await this.getImage(512, this.media.walletLogoUID);
        this.imgSrc = await this.getImage(512, this.media.walletImageUID);
        if (!this.cd['destroyed']) { this.cd.detectChanges(); }
        //this.googleStyle = GoogleWalletPassStyle[this.cardData?.find(c => c.target == Honeycomb.Common.Enums.WalletTemplateTarget.google).walletStyle];
        //this.appleStyle = AppleWalletPassStyle[this.cardData?.find(c => c.target == Honeycomb.Common.Enums.WalletTemplateTarget.apple).walletStyle];
    }

    getStyle(style: string){
        if(this.cardData.length == 0){
            return ''
        }
        if(style == 'google'){
            const name = GoogleWalletPassStyle[this.cardData?.find(c => c?.target == Honeycomb.Common.Enums.WalletTemplateTarget.google)?.walletStyle] ?? '';
            return name;
        }
        else{
            const name = AppleWalletPassStyle[this.cardData?.find(c => c?.target == Honeycomb.Common.Enums.WalletTemplateTarget.apple)?.walletStyle] ?? '';
            return name;
        }
    }

    getImagePath(imgName: string): string {
        const baseUrl = this.document.baseURI;
        return `${baseUrl}img/${imgName}.png`;
    }

    public getImage(size: number, uid?: string | null): string | null {
        if (!uid) return null;

        const base = this.globals.GetUrlPrefix().replace(/\/+$/, '');
        const id = encodeURIComponent(uid);
        const tenant = encodeURIComponent(this.globals.getTenantID());

        return `${base}/api/gallery/thumbByID/${size}/${id}?tenantID=${tenant}`;
    }

    openDetail(tab: number = 0) {
        this.globals.navigateTo(`/communication/digital-cards/detail/${this.media.mediaID}?tab=${tab}`,
        { 
          relativeToParent: true,
          locKey: 'admin.web.digital-cards', 
          detailName: this.media.description
        });
    }

}
